"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
exports.CodeBenchPanelv2 = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var classnames_1 = __importDefault(require("classnames"));
var react_1 = __importDefault(require("react"));
var transactionV2_1 = require("../transactions/transaction/transactionV2");
var transaction_1 = require("../transactions/transaction/transaction");
var error_submission_1 = __importDefault(require("./error-submission"));
var conditional_1 = require("../conditional/conditional");
var ui_common_1 = require("@codametrix/ui-common");
var process_status_1 = require("../process-status/process-status");
var ui_components_1 = require("@codametrix/ui-components");
var svg_icons_1 = __importStar(require("../svgs/svg-icons"));
var invoice_metadatav2_1 = __importDefault(require("./invoice-metadata/invoice-metadatav2"));
var invoice_metadata_form_fixtures_1 = require("./invoice-metadata/invoice-metadata-form-fixtures");
var invoice_card_1 = __importDefault(require("./invoice-components/invoice-card"));
var show_results_1 = require("../transactions/transaction/show-results");
var lookupV2_1 = require("./lookup/lookupV2");
var defaultLookupProps_1 = require("./lookup/defaultLookupProps");
var CodeSearchType = ui_common_1.commonEnums.CodeSearchType;
var DEFAULT_SUGGESTED_CODES = ui_common_1.AmplifyCore.state.DEFAULT_SUGGESTED_CODES;
var CodeBenchPanelv2 = /** @class */ (function (_super) {
    __extends(CodeBenchPanelv2, _super);
    function CodeBenchPanelv2(props) {
        var _this = _super.call(this, props) || this;
        _this.tabContainerRef = react_1["default"].createRef();
        /**
         * Event that happen when Enter key is pressed on  add Invoice link
         * @returns {void}
         */
        _this.handleKeyDown = function (ev) {
            if (ev.key === 'Enter') {
                ev.preventDefault();
                _this.props.handleInvoiceAddition();
            }
        };
        _this.createItemsForTabContainer = function () {
            var _a = _this.props, codableInvoices = _a.codableInvoices, searchResults = _a.searchResults, codeSearchResultsV2 = _a.codeSearchResultsV2, codeEdits = _a.codeEdits, onChargeSessionAction = _a.onChargeSessionAction, panelActivations = _a.panelActivations, processInstance = _a.processInstance, editable = _a.editable, suggestedCodes = _a.suggestedCodes, onFeatureSelection = _a.onFeatureSelection, onCodeSearch = _a.onCodeSearch, onCodeSearchSelection = _a.onCodeSearchSelection, handleAddAllCodes = _a.handleAddAllCodes, handleRemoveAllCodes = _a.handleRemoveAllCodes, createTransactionAndAddCode = _a.createTransactionAndAddCode, onCodeUpdate = _a.onCodeUpdate, onCodeRemove = _a.onCodeRemove, onTimeBasedCodeAdd = _a.onTimeBasedCodeAdd, onTimeBasedCodeUpdate = _a.onTimeBasedCodeUpdate, onCodeSearchDrop = _a.onCodeSearchDrop, onTransactionSharedDiagnosisChange = _a.onTransactionSharedDiagnosisChange, handleEnableTechPro = _a.handleEnableTechPro, handleDisableTechPro = _a.handleDisableTechPro, onInvoiceMetaEdit = _a.onInvoiceMetaEdit, onInvoiceRemove = _a.onInvoiceRemove;
            var counter = 0; // Initialize counter
            var handleInvoiceRemove = function (invoiceGuid) {
                _this.props.onInvoiceRemove({
                    processInstance: processInstance,
                    invoiceGuid: invoiceGuid
                });
            };
            var isEmptyCPTCodeTransaction = function (transaction) {
                var hasProcedureCode = transaction.codes.some(function (code) { return 'codeType' in code && code.codeType === 'procedure'; });
                return !hasProcedureCode;
            };
            var firstEmptyCPTTransactionFound = false; // Tracks if an empty transaction has been found
            var items = codableInvoices.map(function (codableInvoice, idx) {
                var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
                var providerName = (_a = codableInvoice.billing_provider_name) !== null && _a !== void 0 ? _a : '';
                var performingName = (_b = codableInvoice.performing_provider_name) !== null && _b !== void 0 ? _b : '';
                var referringName = (_c = codableInvoice.referring_provider_name) !== null && _c !== void 0 ? _c : '';
                var billArea = (_d = codableInvoice.fee_schedule) !== null && _d !== void 0 ? _d : 'None';
                var department = (_f = (_e = codableInvoice === null || codableInvoice === void 0 ? void 0 : codableInvoice.department) === null || _e === void 0 ? void 0 : _e.name) !== null && _f !== void 0 ? _f : '';
                var dateOfService = codableInvoice.date_of_service
                    ? ui_common_1.cmxDateTime.format(codableInvoice.date_of_service, ui_common_1.cmxDateTime.FORMATS.DATE_OF_SERVICE)
                    : 'Date not selected';
                var txns = codableInvoice.transactions.map(function (txn, txnIdx) {
                    var _a, _b;
                    var rawResults = (_a = searchResults[txn.guid]) !== null && _a !== void 0 ? _a : [];
                    var rawResultsV2 = (_b = codeSearchResultsV2[txn.guid]) !== null && _b !== void 0 ? _b : {};
                    if (codableInvoice.type !== ui_common_1.commonEnums.InvoiceTypes.SHARED_CODES) {
                        counter++;
                    }
                    var shouldAutoFocus = false;
                    // to find first transaction with no CPT code.
                    if (codableInvoice.type !== 'SHARED_CODES' &&
                        isEmptyCPTCodeTransaction(txn) &&
                        !firstEmptyCPTTransactionFound) {
                        firstEmptyCPTTransactionFound = true;
                        shouldAutoFocus = true;
                    }
                    var TransactionComponent = _this.props.transactionV2
                        ? transactionV2_1.TransactionV2
                        : transaction_1.Transaction;
                    var transactionProps = {
                        key: "txn-".concat(txn.guid),
                        codeEdits: codeEdits,
                        onChargeSessionAction: onChargeSessionAction,
                        panelActivations: panelActivations,
                        invoice: codableInvoice,
                        processInstance: processInstance,
                        autoFocus: shouldAutoFocus,
                        editable: editable,
                        onFeatureSelection: onFeatureSelection,
                        searchResults: rawResults,
                        codeSearchResultsV2: rawResultsV2,
                        onCodeSearch: onCodeSearch,
                        onCodeSearchSelection: onCodeSearchSelection,
                        handleAddAllCodes: handleAddAllCodes,
                        handleRemoveAllCodes: handleRemoveAllCodes,
                        createTransactionAndAddCode: createTransactionAndAddCode,
                        handleCodeChange: onCodeUpdate,
                        handleCodeRemove: onCodeRemove,
                        handleTimeBasedCodeAdd: onTimeBasedCodeAdd,
                        handleTimeBasedCodeUpdate: onTimeBasedCodeUpdate,
                        handleCodeSearchDrop: onCodeSearchDrop,
                        onTransactionSharedDiagnosisChange: onTransactionSharedDiagnosisChange,
                        lineNumber: counter,
                        codableTransaction: txn,
                        suggestedCodes: suggestedCodes,
                        handleEnableTechPro: handleEnableTechPro,
                        handleDisableTechPro: handleDisableTechPro,
                        scrollContainerRef: _this.tabContainerRef
                    };
                    return (0, jsx_runtime_1.jsx)(TransactionComponent, __assign({}, transactionProps));
                });
                /**
                 * Event triggered when a search selection is pressed to create a transaction and add code
                 * @param ev
                 */
                var createTransactionAndAddCode = function (searchResult) {
                    var searchSelection = __assign(__assign({}, searchResult), { context: {
                            invoice: __assign({}, codableInvoice),
                            processInstance: __assign({}, _this.props.processInstance)
                        } });
                    _this.props.createTransactionAndAddCode(searchSelection);
                };
                /**
                 * Event launched when a search is performed
                 * @param ev
                 */
                var onSearch = function (codeQuery) {
                    _this.props.onCodeSearch(__assign(__assign({}, codeQuery), { context: {
                            invoice: __assign({}, codableInvoice),
                            processInstance: __assign({}, _this.props.processInstance)
                        } }));
                };
                var invoiceType = (_h = (_g = codableInvoice === null || codableInvoice === void 0 ? void 0 : codableInvoice.type) === null || _g === void 0 ? void 0 : _g.toLowerCase().replace(/_/g, '-')) !== null && _h !== void 0 ? _h : 'unknown';
                var additionalInvoiceCardClasses = [
                    'codable-invoice',
                    'qa-codable-invoice',
                    "invoice-".concat(invoiceType)
                ];
                //`invoice-${invoiceType}`
                var invoiceBody = ((0, jsx_runtime_1.jsxs)(invoice_card_1["default"], __assign({ additionalClasses: additionalInvoiceCardClasses }, { children: [(0, jsx_runtime_1.jsx)("div", __assign({ className: "invoice-meta" }, { children: (0, jsx_runtime_1.jsxs)("div", __assign({ className: "invoice-meta-line invoice-meta-provider" }, { children: [editable && ((0, jsx_runtime_1.jsx)(error_submission_1["default"], { errorMessages: codableInvoice === null || codableInvoice === void 0 ? void 0 : codableInvoice.errorMessages, messageStyle: "inv-error-message", messageType: "error" })), (0, jsx_runtime_1.jsx)(invoice_metadatav2_1["default"], { invoice: codableInvoice, onInvoiceMetaEdit: onInvoiceMetaEdit, fields: invoice_metadata_form_fixtures_1.InvoiceMetadataFormFields, editable: editable, onInvoiceRemove: handleInvoiceRemove })] })) })), txns, (0, jsx_runtime_1.jsx)(conditional_1.Conditional, __assign({ every: [editable, !invoiceType.includes('shared')], displayMode: "flex" }, { children: (0, jsx_runtime_1.jsxs)("div", __assign({ className: "add-transaction-with-code-section" }, { children: [(0, jsx_runtime_1.jsx)(lookupV2_1.SuggestedLookup, { actionPrefix: "", placeholderText: "Add procedure code", debounceTimeout: 200, FieldDefinitions: defaultLookupProps_1.DefaultLookupProps.FieldDefinitions.filter(function (def) { return def.label.toLowerCase() === 'procedure'; }), shouldShowResults: show_results_1.shouldShowResults, autoFocus: false, onSearch: onSearch, onSearchSelection: createTransactionAndAddCode, searchResults: (_k = (_j = codeSearchResultsV2 === null || codeSearchResultsV2 === void 0 ? void 0 : codeSearchResultsV2[codableInvoice === null || codableInvoice === void 0 ? void 0 : codableInvoice.guid]) === null || _j === void 0 ? void 0 : _j[CodeSearchType.CPT]) !== null && _k !== void 0 ? _k : [], searchResultsLookupKey: codableInvoice === null || codableInvoice === void 0 ? void 0 : codableInvoice.guid, showSearchButton: false, actionNameForDD: "~Focus code search (General)", suggestedCodes: suggestedCodes, allowCodeRemove: false }), (0, jsx_runtime_1.jsx)(svg_icons_1.CMXIcon, { svgIconName: "BiomeChevronDownSVG20", svgIconSize: "16", svgIconClass: "select-chevron" })] })) }))] }), "invoice-".concat(idx)));
                return {
                    headerText: dateOfService,
                    subheaderText: providerName,
                    body: invoiceBody
                };
            });
            return { items: items, counter: counter };
        };
        _this.state = {
            editState: {
                add: false
            }
        };
        return _this;
    }
    CodeBenchPanelv2.prototype.parseDate = function (dateString) {
        var _a = __read(dateString.split('/').map(Number), 3), month = _a[0], day = _a[1], year = _a[2];
        return new Date(year, month - 1, day);
    };
    CodeBenchPanelv2.prototype.sortItems = function (itemsToSort) {
        var _this = this;
        return itemsToSort.sort(function (a, b) {
            var dateA = _this.parseDate(a.headerText);
            var dateB = _this.parseDate(b.headerText);
            // Compare the dates
            if (dateA < dateB)
                return -1;
            if (dateA > dateB)
                return 1;
            // Compare the provider names
            var providerA = a.subheaderText.toLowerCase();
            var providerB = b.subheaderText.toLowerCase();
            if (providerA < providerB)
                return -1;
            if (providerA > providerB)
                return 1;
            return 0;
        });
    };
    CodeBenchPanelv2.prototype.render = function () {
        var _a;
        var _b = this.props, searchResults = _b.searchResults, counts = _b.counts, editable = _b.editable, benchEditable = _b.benchEditable, benchLoading = _b.benchLoading, onCodeSearch = _b.onCodeSearch, onCodeSearchSelection = _b.onCodeSearchSelection, handleAddAllCodes = _b.handleAddAllCodes, handleRemoveAllCodes = _b.handleRemoveAllCodes, createTransactionAndAddCode = _b.createTransactionAndAddCode, onCodeUpdate = _b.onCodeUpdate, onCodeRemove = _b.onCodeRemove, onTimeBasedCodeAdd = _b.onTimeBasedCodeAdd, onTimeBasedCodeUpdate = _b.onTimeBasedCodeUpdate, onCodeSearchDrop = _b.onCodeSearchDrop, onFeatureSelection = _b.onFeatureSelection, onChargeSessionMetaEdit = _b.onInvoiceMetaEdit, onChargeSessionAction = _b.onChargeSessionAction, onTransactionSharedDiagnosisChange = _b.onTransactionSharedDiagnosisChange, panelActivations = _b.panelActivations, codableInvoices = _b.codableInvoices, processInstance = _b.processInstance, codeEdits = _b.codeEdits, showProcessStatus = _b.showProcessStatus, caseDetailProps = _b.caseDetailProps, handleEnableTechPro = _b.handleEnableTechPro, handleDisableTechPro = _b.handleDisableTechPro, customClaimsRelatedCases = _b.customClaimsRelatedCases, customClaimsRelatedCasesLoadState = _b.customClaimsRelatedCasesLoadState, openChildWindow = _b.openChildWindow, rest = __rest(_b, ["searchResults", "counts", "editable", "benchEditable", "benchLoading", "onCodeSearch", "onCodeSearchSelection", "handleAddAllCodes", "handleRemoveAllCodes", "createTransactionAndAddCode", "onCodeUpdate", "onCodeRemove", "onTimeBasedCodeAdd", "onTimeBasedCodeUpdate", "onCodeSearchDrop", "onFeatureSelection", "onInvoiceMetaEdit", "onChargeSessionAction", "onTransactionSharedDiagnosisChange", "panelActivations", "codableInvoices", "processInstance", "codeEdits", "showProcessStatus", "caseDetailProps", "handleEnableTechPro", "handleDisableTechPro", "customClaimsRelatedCases", "customClaimsRelatedCasesLoadState", "openChildWindow"]);
        var styleClasses = ['code-bench-panelv2'];
        var _c = this.createItemsForTabContainer(), items = _c.items, counter = _c.counter;
        var noInvoices = ((0, jsx_runtime_1.jsxs)("div", __assign({ className: "no-transactions" }, { children: [(0, jsx_runtime_1.jsx)("div", __assign({ className: "empty-message editable" }, { children: "This case does not have any charges. Add a service date and providers with the charge button below, then add procedures to the set." })), (0, jsx_runtime_1.jsx)(conditional_1.Conditional, __assign({ on: editable }, { children: (0, jsx_runtime_1.jsxs)("div", __assign({ className: "add-element-div", tabIndex: 0, onKeyDown: this.handleKeyDown, onClick: this.props.handleInvoiceAddition }, { children: [(0, jsx_runtime_1.jsx)(svg_icons_1["default"], { svgIconName: "BiomePlusCircle", svgIconSize: "20" }), (0, jsx_runtime_1.jsx)("a", __assign({ className: "add-element-button" }, { children: "Add invoice" }))] })) }))] })));
        return ((0, jsx_runtime_1.jsxs)("div", __assign({}, rest, { className: (0, classnames_1["default"])(styleClasses) }, { children: [showProcessStatus && ((0, jsx_runtime_1.jsx)("div", __assign({ className: "status-section process-status-section" }, { children: (0, jsx_runtime_1.jsx)(process_status_1.ProcessStatus, { benchEditable: benchEditable }) }))), (customClaimsRelatedCasesLoadState === null || customClaimsRelatedCasesLoadState === void 0 ? void 0 : customClaimsRelatedCasesLoadState.loading) ? ((0, jsx_runtime_1.jsx)(ui_components_1.LoadingSlugs, { numberItems: 5 })) : (((_a = processInstance === null || processInstance === void 0 ? void 0 : processInstance.errorMessages) === null || _a === void 0 ? void 0 : _a.length) > 0 && ((0, jsx_runtime_1.jsx)(error_submission_1["default"], { errorMessages: processInstance.errorMessages, messageHeader: benchEditable.submitted
                        ? 'We have found the following errors:'
                        : 'We have found the following that reduce the coding quality of this case:', customClaimsRelatedProps: {
                        cases: customClaimsRelatedCases,
                        onOpenRelatedCase: this.props.openChildWindow,
                        applyErrorTextStyle: !benchEditable.submitted
                    }, messageStyle: "case-error-message", messageType: benchEditable.submitted ? 'warning' : 'error' }))), counter === 0 ? (noInvoices) : items.length > 1 ? ((0, jsx_runtime_1.jsx)(ui_components_1.InteractiveTabContainer, __assign({ items: this.sortItems(items.slice(1)), alwaysFirstElement: items[0].body }, (editable && {
                    action: {
                        label: 'Add',
                        onAction: this.props.handleInvoiceAddition
                    }
                }), { footerElement: this.props.summarySection, scrollContainerRef: this.tabContainerRef }), codableInvoices.length)) : ((0, jsx_runtime_1.jsx)(ui_components_1.InteractiveTabContainer, { items: items }, codableInvoices.length))] })));
    };
    CodeBenchPanelv2.displayName = 'CodeBenchPanel';
    CodeBenchPanelv2.defaultProps = {
        onCodeUpdate: function (changeDetail) { },
        onCodeRemove: function (changeDetail) { },
        onTimeBasedCodeAdd: function (changeDetail, time, age) { },
        onTimeBasedCodeUpdate: function (changeDetail, time, age) { },
        onCodeSearchDrop: function (changeDetail) { },
        onCodeSearch: function (codeQuery) { },
        onCodeSearchSelection: function (searchSelection) { },
        handleAddAllCodes: function (searchSelection) { },
        handleRemoveAllCodes: function (codeChange) { },
        createTransactionAndAddCode: function (searchSelection) { },
        onTransactionSharedDiagnosisChange: function (changeDetail) { },
        onFeatureSelection: function (feature) { },
        onInvoiceMetaEdit: function (invoice) { },
        onInvoiceRemove: function (invoiceDeleteParams) { },
        onChargeSessionAction: function (transactionAction) { },
        handleEnableTechPro: function (transactionCodeChange) { },
        handleDisableTechPro: function (transactionCodeChange) { },
        codableInvoices: [],
        searchResults: {},
        codeSearchResultsV2: {},
        editable: true,
        panelActivations: {},
        codeEdits: {},
        counts: {
            procedures: 0,
            diagnosis: 0,
            modifiers: 0
        },
        suggestedCodes: __assign({}, DEFAULT_SUGGESTED_CODES)
    };
    return CodeBenchPanelv2;
}(react_1["default"].Component));
exports.CodeBenchPanelv2 = CodeBenchPanelv2;
//# sourceMappingURL=code-bench-panelv2.js.map